import * as types from "../../constants";
import { AppDispatchType } from "../store";
import {
  fetchUnits as unitsFetchUnits,
  createUnit as unitsCreateUnit,
  updateUnit as unitsUpdateUnit,
  deleteUnit as unitsDeleteUnit,
  createUnitLevels as unitsLevelCreateUnit,
  updateUnitLevels as unitsLevelUpdateUnit,
  deleteUnitLevels as unitsLevelDeleteUnit,
  fetchUnitsLevels as unitsLevelFetchUnit, fetchUnitsAll
} from "../../services/unitsService";
import { DispatchOf } from "../utils";
import { UnitsActions } from "../reducers/unitsReducer";
import { AccessibilityUnitLevelRequest } from "../../models/AccessibilityUnitLevel";
import {ErrorsActions} from "../reducers/toastsReducer";

export function fetchUnits(property: string, token: string) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsFetchUnits(property, token)
      .then((response: any) => {
        dispatch({
          type: types.FETCH_UNITS,
          units: response.data.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}
export function clearUnits() {
  return ({
    type: types.CLEAR_UNITS,
  })
}

export function createUnit(data: object, token: string) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsCreateUnit(data, token)
      .then((response: any) => {
        dispatch({
          type: types.CREATE_UNIT,
          unit: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function deleteUnit(token: string, id: string) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsDeleteUnit(token, id)
      .then((response: any) => {
        dispatch({
          type: types.DELETE_UNIT,
          unit: { response, id },
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updateUnit(data: object, token: string, id: string, index: number) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsUpdateUnit(data, token, id)
      .then((response: any) => {
        dispatch({
          type: types.UPDATE_UNIT,
          payload: { response, index },
        });
        return response;
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function fetchUnitLevels(property: string, token: string) {
  if (!property) return
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsLevelFetchUnit(property, token)
      .then((response: any) => {
        dispatch({
          type: types.FETCH_UNIT_LEVELS,
          unit_levels: response.data.results,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}


export function createUnitLevels(data: AccessibilityUnitLevelRequest, token: string) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {
    return unitsLevelCreateUnit(data, token)
      .then((response: any) => {
        dispatch({
          type: types.CREATE_UNIT_LEVELS,
          unit: response.data,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function updateUnitLevels(data: AccessibilityUnitLevelRequest, token: string, id: string, index: number) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsLevelUpdateUnit(data, token, id)
      .then((response: any) => {
        dispatch({
          type: types.UPDATE_UNIT_LEVELS,
          payload: { response, index },
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}

export function deleteUnitLevels(token: string, id: string, index: number) {
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {

    return unitsLevelDeleteUnit(token, id)
      .then((response: any) => {
        // dispatch({
        //   type: types.DELETE_UNIT_LEVELS,

        //   // payload: {response, index},
        // });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
  };
}


export function fetchAccessibilityUnitsCounts(token: string, companyId?: string) {
  let query: any = {
    fields: 'is_accessible_unit',
    is_accessible_unit: true,
    limit: 1
  }
  if (companyId) {
    query.property__company = companyId
  }

  let result = [
    {name: 'statsPage_accessible', value: 0},
    {name: 'statsPage_notAccessible', value: 0}
  ]
  return async (dispatch: DispatchOf<UnitsActions> & DispatchOf<ErrorsActions>) => {
    return fetchUnitsAll(token, query).then((response: any) => {
      result[0].value = response.data.count
      query.is_accessible_unit = false
      fetchUnitsAll(token,query).then((response: any) => {
        result[1].value = response.data.count
        dispatch({
          type: types.FETCH_ACCESSIBILITY_UNITS_COUNTS,
          payload: result,
        });
      }).catch((error) => {
        dispatch({
          type: types.ADD_TOAST,
          payload: error
        })
      })
    }).catch((error) => {
      dispatch({
        type: types.ADD_TOAST,
        payload: error
      })
    })
  };
}

export function clearAccessibilityUnitsCounts() {
  return ({
    type: types.CLEAR_ACCESSIBILITY_UNITS_COUNTS
  })
}
